import clsx from 'clsx';

import Spacer from '@commons/components/Spacer';
import type { DrupalBlock } from '@commons/types/drupal';
import type { Spacing } from '@commons/types/styles';

// Type definition for the SpacerBlock component properties.

type Props = DrupalBlock<{
  size: Spacing;
  fill: boolean;
}>;

/**
 * Spacer block component.
 */

const SpacerBlock = ({ content }: Props) => {
  const { size, fill } = content;
  return <Spacer size={size} className={clsx('w-100', fill && 'flex-fill')} />;
};

/**
 * This block only provides spacing and does not require animation.
 */

SpacerBlock.supportsAnimation = false;

export default SpacerBlock;
